/**
 * Stable CSS class names for E2E — RPT Topic Management page.
 */
export const RTM = {
    page: 'rpt-topic-management-page',

    titleRow: 'rpt-topic-management-page__title-row',
    title: 'rpt-topic-management-page__title',

    actionsRow: 'rpt-topic-management-page__actions-row',
    createButton: 'rpt-topic-management-page-input--button-create',

    drawerPaper: 'rpt-topic-management-page__drawer-paper',
    drawerContent: 'rpt-topic-management-page__drawer-content',

    dataGridWrap: 'rpt-topic-management-page__data-grid-wrap',

    cellTopicNameWrap: 'rpt-topic-management-page__cell-topic-name-wrap',
    cellTopicNameText: 'rpt-topic-management-page__cell-topic-name-text',
    cellTopicNameTooltip: 'rpt-topic-management-page__cell-topic-name-tooltip',

    cellEditButton: 'rpt-topic-management-page-input--button-cell-edit',
    cellEditIcon: 'rpt-topic-management-page__cell-edit-icon',

    cellDeleteButton: 'rpt-topic-management-page-input--button-cell-delete',
    cellDeleteIcon: 'rpt-topic-management-page__cell-delete-icon',
} as const;

export const rtmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

